import { render, staticRenderFns } from "./MaterialLabelTabs.vue?vue&type=template&id=b65d347a&scoped=true&"
import script from "./MaterialLabelTabs.vue?vue&type=script&lang=js&"
export * from "./MaterialLabelTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65d347a",
  null
  
)

export default component.exports